import { render, staticRenderFns } from "./submit-task-budget.vue?vue&type=template&id=1c3bcc4e&"
import script from "./submit-task-budget.vue?vue&type=script&lang=js&"
export * from "./submit-task-budget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports